import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import AddressBlock from "../../components/addAddress/addressBlock";
import {
  selectCustomerAddresses,
  selectSelectedAddress,
} from "../../redux/features/customer/customerSelectors";
import { transformAddresses } from "../../utils/addresses";
import { getBrandsByAreaAsync } from "../../redux/features/restaurants/restaurantThunks";
import { setSelectedAddress } from "../../redux/features/customer/customerSlice";

export const AddressSelection = ({ isCheckout = false, setShowAddressForm }) => {
  const addressData = useSelector(selectCustomerAddresses);
  const selectedAddress = useSelector(selectSelectedAddress);
  const addresses = addressData && transformAddresses(addressData);
  const dispatch = useDispatch();

  // State to track the selected address ID
  const [selectedAddressId, setSelectedAddressId] = useState(
    selectedAddress?.id || null
  );

  // Handle address selection/deselection
  const handleSelectAddress = (id) => {
    console.log("Selected address ID:", id); // Debug log
    setSelectedAddressId(id);

    // If id is null, deselect current address
    if (id === null) {
      dispatch(setSelectedAddress(null));
      return;
    }

    // Find the address object with the matching ID
    const selectedAddressObj = addresses.find((address) => address.id === id);

    if (selectedAddressObj) {
      // Dispatch to Redux
      dispatch(setSelectedAddress(selectedAddressObj));

      // Fetch brands for the selected area
      if (selectedAddressObj.area) {
        dispatch(
          getBrandsByAreaAsync({
            areaName: selectedAddressObj.area,
            serviceType: "delivery",
          })
        );
      }
    }
  };

  // Set selected address ID from Redux on mount and when it changes
  useEffect(() => {
    // Only update if there's a change to prevent loops
    if (selectedAddress?.id !== selectedAddressId) {
      setSelectedAddressId(selectedAddress?.id || null);
    }
  }, [selectedAddress]);

  // Initialize brands data on component mount if a selected address exists
  useEffect(() => {
    if (selectedAddress && selectedAddress.area) {
      // Dispatch action to populate brands based on the selected address area
      dispatch(
        getBrandsByAreaAsync({
          areaName: selectedAddress.area,
          serviceType: "delivery",
        })
      );
    }
  }, [dispatch, selectedAddress]);

  // Uncomment this to automatically select the first address when none is selected
  /*
  useEffect(() => {
    if (!selectedAddress && addresses && addresses.length > 0) {
      const firstAddress = addresses[0];
      handleSelectAddress(firstAddress.id);
    }
  }, [addresses, selectedAddress]);
  */

  return (
    <div className="flex flex-col w-full">
      {/* Scrollable Address List */}
      {addresses && (
        <h1 className="text-3xl font-bold text-gray-500 mb-4">Address List</h1>
      )}
      {addresses && (
        <div className="w-full overflow-y-auto overflow-x-hidden max-h-[550px] pr-2">
          <div
            className="grid gap-6"
            style={{
              gridTemplateColumns: "repeat(auto-fill, minmax(257px, 1fr))",
              // justifyItems: "center"
            }}
          >
            {addresses.map((address, index) => (
              <AddressBlock
                key={address.id || index}
                address={address}
                isAddressBlockVisible
                isSelected={selectedAddressId === address.id}
                onSelect={(id) =>
                  handleSelectAddress(id === null ? null : address.id)
                }
                selectedAddress={selectedAddress}
                isCheckout={isCheckout}
                showSwitchButton={
                  isCheckout && selectedAddressId !== address.id
                }
                setShowAddressForm={setShowAddressForm}
              />
            ))}
          </div>
        </div>
      )}

      {/* Removed AddNewAddress component since it's now in the UserSearch component */}
    </div>
  );
};
